import get from 'lodash/get';
import ContentItemWithResolver from "models/ContentItemWithResolver";

export default class CaseStudiesSectionTranslation extends ContentItemWithResolver {
	get translation(): string {
		return get(this, '_translation.value', '');
	}

	get caseStudiesSectionCodeName(): string {
		return get(this, '_case_studies_sections.taxonomyTerms[0].codename', '');
	}
}
